import { ActiveDiagram } from 'src/containers/ProjectDiagram/types/diagram';
import * as collaborationProvider from 'src/utils/collaboration/collaborationProvider';

/**
 * Clear the diagram's undo history so a programmatic change (new draft, model
 * refresh, project-settings save, etc.) cannot be undone.
 *
 * Clears both the offline GoJS UndoManager and, when collaboration is
 * connected, the project's Y.UndoManager (VET-6292) — otherwise the change
 * would remain undoable through the collaboration undo stack.
 */
export const clearDiagramUndoHistory = (
  diagram: ActiveDiagram | undefined,
  projectId: string
) => {
  if (diagram && !diagram.headless) {
    diagram.undoManager.clear();
  }
  collaborationProvider.getUndoManager(projectId)?.clear();
};
